export default __webpack_public_path__ + "static/media/modell.b39fc2c1.png";